module.exports = __webpack_public_path__ + "static/media/mars4.17d38c2f.png";